import axiosInstanceNew from "../lib/axiosinstanceNew";

const VedioModel = class {
  
  constructor() {
    this.baseUrl = "videos";
  }
  async list(data = []) {
    return (
      await axiosInstanceNew.get(`${this.baseUrl}`)
    ).data;
  }
  async addvedio(data= []) {
    return (
      await axiosInstanceNew.post(`${this.baseUrl}`,data))
  }
  async editvedio(id, data= []) {
    return (
      await axiosInstanceNew.put(`${this.baseUrl}/${id}`,data))
  }
  async deletevedio(id) {
    return (
      await axiosInstanceNew.delete(`${this.baseUrl}/${id}`))
  }
};

export default new VedioModel();
